<template>
    <div class="home-sidebar">
        <div class="home-sidebar-top">
          <p class="home-sidebar-top-content">
            <img src="../assets/images/plat-logo.png" />
            <span class="home-introduction">Overview</span>
          </p>
        </div>

        <div class=" home-sidebar-card-group">
          <div class="case-item" 
            v-for="(item, index) in leftMenu"
            :key="index"
            @click="openArea(item.area, index)"
          >
            <div class="ih-item" >
              <!-- :class=" index == 3 ? 'ih-item4' : '' " -->
              <!-- :class="index == 3 ? 'img4' : ''" -->
              <div class="img" ><img :src="item.url"></div>
              <div class="jiao"><img :src="item.jiao" /></div>
              <div class="info">
              </div>
              <!-- <div class="info" :class="index == 3 ? 'info4' : ''">
                <div :style="{display: (index===3 ? 'block' : 'none')}">Coming Soon!</div>
              </div> -->
              <div class="infoText" :class=" index == 3 ? 'infoText4' : '' ">
                <!-- <template v-if="index == 3">
                  <div class="area">{{item.areaText}}</div>
                </template>
                <template v-else> -->
                  <div class="text">{{item.textTitle}}</div>
                  <div class="area">{{item.areaText}}</div>
                <!-- </template> -->
              </div>
            </div>
          </div>
        </div>

        <p class="home-href-address">
			<span v-for="(item, index) in homeLink" :key="index">
				<a
				:href="item.url"
				target="_blank">{{item.name}}</a>
			</span>
        </p>
	</div>
</template>
<script>
  export default {
    name: 'App',
    data () {
      return {
        leftMenu: [
          {
            url: require('../assets/images/home-left-global.png'),
            textTitle: 'FengYun Satellite',
            areaText: '- Global',
            jiao: require('../assets/images/jiao1.png'),
          },
          {
            url: require('../assets/images/home-left-asia.png'),
            textTitle: 'FengYun Satellite',
            areaText: '- Asia',
            jiao: require('../assets/images/jiao2.png'),
          },
          {
            url: require('../assets/images/home-left-arab.png'),
            textTitle: 'FengYun Satellite',
            areaText: '- Arab States',
            jiao: require('../assets/images/jiao3.png'),
          },
          {
            url: require('../assets/images/home-left-UAE.png'),
            textTitle: 'FengYun Satellite',
            areaText: '- Country',
            // areaText: 'Coming Soon!',
            jiao: require('../assets/images/jiao4.png'),
          }
        ],
        // leftMenu: window.fyEarth.homeLeftMenu,
        homeLink: window.fyEarth.homeLink
      }
    },
    created(){
      this.leftMenu.map((val, index)=>{
        window.fyEarth.homeLeftMenu.map((item, idx)=>{
          if(index === idx){
            return val.area = item.area
          }
        })
      })
    },
    methods: {
      openArea(params, index) {
        localStorage.setItem("fyearth-tabIndex", 0);
        if(index == 3){
          window.open(window.fyEarth.homeLeftMenu[window.fyEarth.homeLeftMenu.length - 1].area)
        } else if(index == 2){
          // this.$router.push("/area/" + params + window.fyEarth.headerNav[0].path)
          window.open(window.fyEarth.homeLeftMenu[index].area)
        } else {
          this.$router.push("/area/" + params + window.fyEarth.headerNav[1].path)
        }
      },
    }
  }
</script>
<style scoped>
</style>